import React, { useState } from "react";
import PropTypes from "prop-types";
import { TableRow, TableCell, makeStyles } from "@material-ui/core";
import translate from "i18n/translate";
import ExpandableRow from "./ExpandableRow";
import ChipCell from "./ChipCell";
import { DISTRIBUTOR_TYPE } from "../constants";
import { SrCurrency } from "../../../../common";

export const useStyles = makeStyles(() => ({
  rowWithExpandableContentOpen: {
    visibility: "collapse",
    "& td": {
      border: "none",
    },
  },
  selectable: {
    cursor: "pointer",
  },
}));

const Row = ({ row, type }) => {
  const [isOpen, setIsOpen] = useState(row.isOpen);
  const classes = useStyles();
  const expandRowClick = row.expandableRow
    ? () => {
        setIsOpen(!isOpen);
      }
    : undefined;

  return (
    <>
      <TableRow
        className={[
          isOpen ? classes.rowWithExpandableContentOpen : "",
          classes.selectable,
        ].join(" ")}
        onClick={expandRowClick}
        hover
      >
        <TableCell>
          <ChipCell
            warning
            chipValue={row.referal.outcost}
            value={row.referal.name}
          />
        </TableCell>
        <TableCell align="center">
          <ChipCell
            chipValue={row.operations.distributorCode}
            value={row.operations.inCostCount}
          />
        </TableCell>
        <TableCell>
          <SrCurrency value={row.transacted} />
        </TableCell>
        {type === DISTRIBUTOR_TYPE.master && (
          <TableCell>
            {translate(`distributors.${row.type ? "distributor" : "client"}`)}
          </TableCell>
        )}
        <TableCell>
          <SrCurrency value={row.commisions} />
        </TableCell>
        {type === DISTRIBUTOR_TYPE.master && (
          <>
            <TableCell>
              <SrCurrency value={row.cost} />
            </TableCell>
            <TableCell>
              <SrCurrency value={row.net} />
            </TableCell>
          </>
        )}
        <TableCell>
          <SrCurrency value={row.distributor} />
        </TableCell>
      </TableRow>
      {row.expandableRow && (
        <ExpandableRow
          type={type}
          isOpen={isOpen}
          data={row}
          onClose={expandRowClick}
        />
      )}
    </>
  );
};

Row.propTypes = {
  row: PropTypes.shape({
    expandableRow: PropTypes.shape({}),
  }),
  type: PropTypes.string.isRequired,
};

Row.defaultProps = {
  row: {
    expandableRow: false,
  },
};

export default Row;
